import { Component } from '@angular/core';

@Component({
  selector: 'app-help',
  standalone: false,
  templateUrl: './help.html',
  styleUrl: './help.less'
})
export class Help {

}
